import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwipeAction } from './swipe-action.component';

@NgModule({
  imports: [CommonModule],
  exports: [SwipeAction],
  declarations: [SwipeAction],
  providers: [],
})

export class SwipeActionModule { }
